import {MatPaginatorIntl} from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
const customPaginatorIntl = new MatPaginatorIntl();

export function setLangOfPaginator(translate, customPaginatorIntl: MatPaginatorIntl) {
    if (!translate) { return; }
    customPaginatorIntl.itemsPerPageLabel = translate.PAGINATOR.itemsPerPageLabel;
    customPaginatorIntl.firstPageLabel = translate.PAGINATOR.firstPageLabel;
    customPaginatorIntl.lastPageLabel = translate.PAGINATOR.lastPageLabel;
    customPaginatorIntl.nextPageLabel = translate.PAGINATOR.nextPageLabel;
    customPaginatorIntl.previousPageLabel = translate.PAGINATOR.previousPageLabel;
    customPaginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 ${translate.PAGINATOR.OF} ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} – ${endIndex} ${translate.PAGINATOR.OF} ${length}`;
    };
    return customPaginatorIntl;
}
export function CustomPaginator(translateService: TranslateService) {
    const translate = translateService.translations[translateService.currentLang];
    setLangOfPaginator(translate, customPaginatorIntl);
    return customPaginatorIntl;
}



// WEBPACK FOOTER //
// ./src/app/helpers/CustomPaginator.ts